/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 43f96b2d (Wed Dec  3 21:51:26 UTC 2025)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import {
  PaginationResponse,
  PaginationResponseFromJSON,
  PaginationResponseToJSON,
  UserRoleAssignment,
  UserRoleAssignmentFromJSON,
  UserRoleAssignmentToJSON,
} from './'

/**
 *
 * @export
 * @interface FetchUserRolesResponse
 */
export interface FetchUserRolesResponse {
  /**
   * The active roles that this user account currently has.
   * @type {Array<UserRoleAssignment>}
   * @memberof FetchUserRolesResponse
   */
  roles?: Array<UserRoleAssignment>
  /**
   *
   * @type PaginationResponse
   * @memberof FetchUserRolesResponse
   */
  pagination?: PaginationResponse
}

export function FetchUserRolesResponseFromJSON(
  json: any
): FetchUserRolesResponse {
  return FetchUserRolesResponseFromJSONTyped(json, false)
}

export function FetchUserRolesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FetchUserRolesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    roles: !exists(json, 'roles')
      ? undefined
      : (json['roles'] as Array<any>).map(UserRoleAssignmentFromJSON),
    pagination: !exists(json, 'pagination')
      ? undefined
      : PaginationResponseFromJSON(json['pagination']),
  }
}

export function FetchUserRolesResponseToJSON(
  value?: FetchUserRolesResponse | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    roles:
      value.roles === undefined
        ? undefined
        : (value.roles as Array<any>).map(UserRoleAssignmentToJSON),
    pagination: PaginationResponseToJSON(value.pagination),
  }
}
